/**
 * Public retake-fee lookup client.
 *
 * Hits POST /api/public/retake-fee/lookup — anonymous endpoint, no JWT
 * needed. The server returns EC: 0 with a tagged DT.status for both
 * success and "no fee" cases (passed / notFound / noAdminLink /
 * noFeeConfig); only invalid input or a server error return EC: -1.
 */

import axios from 'axios';
import type { RetakeFeeLookupResult } from '../types';

export type ApiRes<T> = { EM: string; EC: number; DT: T };

export const lookupRetakeFeeApi = (cccd: string) =>
  axios
    .post<ApiRes<RetakeFeeLookupResult>>('/api/public/retake-fee/lookup', { cccd })
    .then((r) => r.data);
